import React from 'react';
import styled from 'styled-components';
import { usePagination, useTable, useSortBy } from 'react-table';

const EditableTable = (props) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    nextPage,
    previousPage,
    state: { pageIndex },
  } = useTable(
    {
      columns: props.columns,
      data: props.data,
      initialState: { pageIndex: 0, pageSize: 20 },
    },
    useSortBy,
    usePagination,
  );

  return (
    <div>
      <Styles>
        <table {...getTableProps()}>
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                    {column.render('Header')}
                    <span>
                      {column.isSorted
                        ? column.isSortedDesc
                          ? ' 🔽'
                          : ' 🔼'
                        : ''}
                    </span>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          {props.data.length === 0 && (
            <EmptyList>Nessun risultato trovato</EmptyList>
          )}

          <tbody {...getTableBodyProps()}>
            {page.map((row, i) => {
              prepareRow(row);

              return (
                <tr
                  {...row.getRowProps()}
                  style={{ backgroundColor: row?.original?.highlight }}
                >
                  {row.cells.map((cell) => {
                    return (
                      <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>

        {props.data.length ? (
            <Pagination>
              {props.onPageChange ? (
                  <>
                    {props.page !== 0 ? (
                        <button onClick={() => props.onPageChange(props.page - 1)}>
                          {'<'}
                        </button>
                    ) : ''}
                    <span>
                      Pagina {props.page + 1} di {props.pages}
                    </span>
                    {props.page + 1 !== props.pages ? (
                        <button onClick={() => props.onPageChange(props.page + 1)}>
                          {'>'}
                        </button>
                    ) : ''}
                  </>
              ) : (
                  <>
                    {canPreviousPage ? (
                        <button onClick={() => previousPage()}>
                          {'<'}
                        </button>
                    ) : ''}
                    <span>
                      Pagina {pageIndex + 1} di {pageOptions.length}
                    </span>
                    {canNextPage ? (
                        <button onClick={() => nextPage()}>
                          {'>'}
                        </button>
                    ) : ''}
                  </>
              )}
            </Pagination>
        ) : ''}
      </Styles>
    </div>
  );
};

export default EditableTable;

const Styles = styled.div`
  display: block;
  padding: 8px 0;
  overflow-x: auto;
  position: relative;
  min-height: 200px;

  table {
    width: 100%;
    background: #ffffff;
    border-spacing: 0;
    margin-bottom: 2em;
  }

  tr {
    min-height: 32px;
  }

  th {
    padding: 10px;
    font-weight: bold;
    font-size: 0.9em;
    text-align: left;
    background-color: #296fa8;
    color: #ffffff;
    border: 1px solid #ffff;
  }

  tr:nth-of-type(even) {
    background-color: #eff5fb;
  }

  td {
    padding: 10px;
    font-size: 0.96em;
    border: 1px solid #e8e8e8;
    vertical-align: middle;
    
    i{
      font-size: 15px
    }
    
    .button {
      padding: 0.4em;
      height: auto;
    }
  }
`;

const Pagination = styled.div`
  display: flex;
  justify-content: center;
  position: fixed; /* Fixes the pagination */
  bottom: 0; /* Sticks it to the bottom */
  left: 0; /* Aligns to the left */
  right: 0; /* Aligns to the right, taking full width */
  background-color: white; /* Sets a background color */
  padding: 8px;
  z-index: 10; /* Brings the pagination to the foreground */
  box-shadow: 0px -2px 5px rgba(0, 0, 0, 0.1); /* Adds shadow for visual separation */

  & span {
    margin: 0 16px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

const EmptyList = styled.div`
  position: absolute;
  background: #ffffff;
  width: 100%;
  min-height: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
